// FilterComponent.js
import React from "react";
import styles from "../style/style";
const FilterComponent = ({ filters, handleFilterChange }) => {
  return (
    <div className="relative h-10  min-w-[250px] sm:min-w-[200px] md:min-w-[230px]">
      <input
        type="text"
        placeholder="Search"
        name="combinedFilter"
        value={filters.combinedFilter}
        onChange={handleFilterChange}
        className={styles.searchInput}
      />
    </div>
  );
};

export default FilterComponent;
